<template>
<div>
    <section class="page-title" style="background-color:#c7eafb;">
        <div class="center">
            <v-layout row wrap>
                <v-flex xs12 sm12 lg8>
                    <p class="label-planos">Convênio Plano Odontológico</p>
                    <h1 class="the-title">Parceria</h1>   
                    <h1 class="the-title" style="font-size:30px;color:#00358d">Sindicato dos Trabalhadores  em<br>Transporte Rodoviário de Catalão - GO</h1>
                </v-flex>  
                
                <v-flex xs12 sm12 lg4 style="text-align: right;" v-if="this.$vuetify.breakpoint.lg">  
                    <br>
                    <br>
                    <br>
                    <img src="../Content/images/Logo-Fiesp.jpg" width="300">
                </v-flex>
                <v-flex xs12 sm12 lg4 style="text-align: center;" v-else>  
                    <img src="../Content/images/Logo-Fiesp.jpg" width="180">
                </v-flex>  
                <v-flex xs12 sm6 md6 lg6>
                    <br>
                    <v-btn
                    style="border-radius: 6px;"
                    large                
                    dark
                    @click="openDialog()"
                    color="#00358d"
                    >Aderir ao ACT
                    </v-btn>
                </v-flex>       
            </v-layout>
        </div>
    </section>

<section class="page-content center">
    <p class="the-title" style="font-size:35px; color:#00358d; text-align:center"><strong>ACORDO COLETIVO DE TRABALHO</strong></p>
    <br>
    <v-layout row wrap>
        <v-flex xs12 sm12 lg12>
            <p class="title-label">O seu sorriso é o nosso diferencial.</p>
            <p>Informamos que para cumprir o ACORDO COLETIVO DE TRABALHO registrada junto ao Ministério do Trabalho e Emprego as empresas deverão fornecer Plano Odontológico para todos os seus empregados, sendo as regras estabelecidas no ACT.</p>
            <p>Caso queira, o trabalhador poderá incluir seus dependentes, em condições especiais, pagando integralmente o valor, através de desconto em folha de pagamento.</p>
            <p>Os valores do plano contratado serão conforme texto no ACT</p>
            <p class="title-label">Faça agora sua adesão a ACT e garanta o sorriso dos seus colaboradores com a PrimaVida Dental.</p>
        </v-flex>

        <v-flex xs12 sm12 lg12>
            <img src="../Content/images/logo.png" width="200">
        </v-flex>

        <v-flex xs12 sm12 lg6>
            <br>
            <p class="title-label">Acesso à rede credenciada</p>
            <p><a href="http://www.primavida.com.br/redecredenciada" target="_blank">http://www.primavida.com.br/redecredenciada</a></p>
            <p class="title-label">Quem pode aderir o plano?</p>
            <p>Dependentes:</p>
            <p>- Cônjuge ou companheiro</p>
            <p>- Mãe ou madrasta</p>
            <p>- Pai ou padrasto</p>
            <p>- Filhos e enteados</p>
        </v-flex>

        <v-col
            cols="6"
        >
            <p class="title-label">Principais Vantagens</p>
            <p>- Dependentes:</p>
            <p>- Liberação on-line do seu plano de tratamento;</p>
            <p>- O Beneficiário pode incluir familiares e agregados;</p>
            <p>- Acesso a rede credenciada através do site <a href="www.primavida.com.br" target="_blank"></a>;</p>
            <p>- Desconto em medicamentos nas farmácias; &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></p>
            <p>- Central de Atendimento exclusiva por WhatsApp;</p>
            <p>- Aplicativo para Celular / Tablet com rede Credenciada;</p>
            <p>- Carteirinha Virtual;</p>
            <p>- Boleto Virtual.</p>
        </v-col>

        <v-flex xs12 sm12 lg12>
            <br>
            <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
            </v-flex>
            <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_android.png" width="120px"><br>
            <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
            </v-flex>
            <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_apple.png" width="120px"><br>
            <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
            </v-flex>
            <v-flex xs5 sm5 lg2>
            <img src="../Content/images/app_whats.png" width="120px"><br>
            <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
            </v-flex>
            <v-flex xs5 sm5 lg3>
            <img src="../Content/images/celular.png" width="130px"><br>
        </v-flex>

        <v-flex xs5 sm5 lg12>
            <table cellpadding="0" cellspacing="0" border="1">
                <tr>
                    <td style="color: #009b9b;">Plano: </td> 
                    <td>&nbsp; SMILE EMPRESARIAL </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Reg ANS nº: </td>
                    <td>&nbsp; 475.861/16-7 </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Tipo de Contratação: </td>
                    <td>&nbsp; COLETIVO EMPRESARIAL </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Formação de Preço: </td>
                    <td>&nbsp; PRÉ-ESTABELECIDO </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
                    <td>&nbsp; NACIONAL </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Segmetação Assistencial: </td>
                    <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
                </tr>
                <tr>
                    <td style="color: #009b9b;">Carência: </td>
                    <td>&nbsp; SEM CARÊNCIA </td>
                </tr>
            </table>
        </v-flex>
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico) e panorâmica;</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>    
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
        <br>
        <!--<p>Ficha de Adesão, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>-->
    </div>

    <v-col cols="12">
        <p><strong>IMPORTANTE:</strong> Favor observar os documentos obrigatórios que devem ser anexados</p>
        <img src="../Content/images/exemploAct.png" width="400px">
    </v-col>

    <v-flex xs12 sm6 md6 lg12 >
        <v-btn
        style="border-radius: 6px;"
        large                
        dark
        @click="openDialog()"
        color="#00358d"
        >Aderir ao ACT</v-btn>
        <img src="../Content/images/logo-ans.png" width="200" style="float:right;">
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'http://localhost:8080/contratost?plano=60f6cd1a5d8bd404bb665b26'">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>